<template>
  <div class="sidebar__wrap" :class="{ show: mobile }">
    <div class="sidebar">
      <img
        src="../../assets/images/logo-white.svg"
        alt="spleet logo"
        class="img-fluid sidebar__logo"
        @click="$router.push({ name: 'dashboard' })"
      />

      <div class="sidebar__section">
        <p class="sidebar__section-title">Core</p>
        <ul class="sidebar__section-content">
          <li
            class="sidebar__item"
            :class="{ active: currentRouteName == 'dashboard' }"
          >
            <router-link to="/dashboard" class="sidebar__link">
              <svgicon icon="overview" class="sidebar__icon"></svgicon>
              <span class="sidebar__text">Dashboard</span>
            </router-link>
          </li>
          <li
            class="sidebar__item"
            :class="{ active: currentRouteName == 'rnpl' }"
          >
            <router-link to="/rnpl" class="sidebar__link">
              <svgicon icon="overview" class="sidebar__icon"></svgicon>
              <span class="sidebar__text">RNPL Dashboard </span>
            </router-link>
          </li>
        </ul>
      </div>

      <div class="sidebar__section">
        <p class="sidebar__section-title">Property Management</p>
        <ul class="sidebar__section-content">
          <li
            class="sidebar__item"
            :class="{
              active:
                currentRouteName == 'listing' ||
                currentRouteName == 'listingDetail'
            }"
          >
            <router-link to="/listing" class="sidebar__link">
              <svgicon icon="listing" class="sidebar__icon"></svgicon>
              <span class="sidebar__text">Listings</span>
            </router-link>
          </li>
          <li
            class="sidebar__item"
            :class="{
              active:
                currentRouteName == 'booking' ||
                currentRouteName == 'bookingDetail'
            }"
          >
            <router-link to="/booking" class="sidebar__link">
              <svgicon icon="booking" class="sidebar__icon"></svgicon>
              <span class="sidebar__text">Booking</span>
            </router-link>
          </li>

          <li
            class="sidebar__item"
            :class="{
              active:
                currentRouteName == 'subscription' ||
                currentRouteName == 'subscriptionDetail'
            }"
          >
            <router-link to="/subscription" class="sidebar__link">
              <svgicon icon="subscription" class="sidebar__icon"></svgicon>
              <span class="sidebar__text">Subscription</span>
            </router-link>
          </li>

          <li
            class="sidebar__item"
            :class="{
              active:
                currentRouteName == 'maintenance' ||
                currentRouteName == 'maintenanceDetail'
            }"
          >
            <router-link to="/maintenance" class="sidebar__link payment">
              <svgicon icon="maintenance" class="sidebar__icon"></svgicon>
              <span>Maintenance Request </span>
            </router-link>
          </li>

          <li
            class="sidebar__item"
            :class="{
              active: currentRouteName == 'verifyRequests'
            }"
          >
            <router-link to="/verify" class="sidebar__link payment">
              <svgicon icon="booking" class="sidebar__icon"></svgicon>
              <span>Verify Requests </span>
            </router-link>
          </li>
        </ul>
      </div>

      <div class="sidebar__section">
        <p class="sidebar__section-title">Users</p>
        <ul class="sidebar__section-content">
          <li
            class="sidebar__item"
            :class="{
              active:
                currentRouteName == 'member' ||
                currentRouteName == 'memberDetail'
            }"
          >
            <router-link to="/members/" class="sidebar__link">
              <svgicon icon="members" class="sidebar__member-icon"></svgicon>
              <span class="sidebar__text">Members</span>
            </router-link>
          </li>
          <li
            class="sidebar__item"
            :class="{
              active: currentRouteName == 'teamMembers'
            }"
          >
            <router-link to="/team-members/" class="sidebar__link">
              <svgicon
                icon="team-mem-group"
                class="sidebar__member-icon"
              ></svgicon>
              <span class="sidebar__text">Team Members</span>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="sidebar__section">
        <p class="sidebar__section-title">Finance & Payment</p>
        <ul class="sidebar__section-content">
          <li
            class="sidebar__item"
            :class="{
              active: currentRouteName == 'invoices'
            }"
          >
            <router-link to="/invoices" class="sidebar__link">
              <svgicon icon="invoice" class="sidebar__icon"></svgicon>
              <span class="sidebar__text">Invoices</span>
            </router-link>
          </li>
          <li
            class="sidebar__item"
            :class="{
              active: currentRouteName == 'settlements'
            }"
          >
            <router-link to="/settlements" class="sidebar__link">
              <svgicon
                icon="settlement"
                class="sidebar__settlement-icon"
              ></svgicon>
              <span class="sidebar__text">Settlements</span>
            </router-link>
          </li>
          <li
            class="sidebar__item"
            :class="{
              active: currentRouteName == 'loans'
            }"
          >
            <router-link to="/loans" class="sidebar__link">
              <svgicon
                icon="settlement"
                class="sidebar__settlement-icon"
              ></svgicon>
              <span class="sidebar__text">Loans </span>
            </router-link>
          </li>
          <li
            class="sidebar__item"
            :class="{
              active: currentRouteName == 'loan-request'
            }"
          >
            <router-link to="/loan-request" class="sidebar__link">
              <svgicon
                icon="settlement"
                class="sidebar__settlement-icon"
              ></svgicon>
              <span class="sidebar__text">Loan Requests</span>
            </router-link>
          </li>

          <li
            class="sidebar__item"
            :class="{
              active: currentRouteName == 'disbursement'
            }"
          >
            <router-link to="/disbursement" class="sidebar__link">
              <svgicon
                icon="settlement"
                class="sidebar__settlement-icon"
              ></svgicon>
              <span class="sidebar__text">Disbursement</span>
            </router-link>
          </li>
          <!-- the referrals -->
           <li
            class="sidebar__item"
            :class="{
              active: currentRouteName == 'referral' || currentRouteName == 'referrerDetail'
            }"
          >
            <router-link to="/referral" class="sidebar__link">
              <svgicon
                icon="team-mem-group"
                class="sidebar__member-icon"
              ></svgicon>
              <span class="sidebar__text">Referrals</span>
            </router-link>
          </li>
        </ul>
      </div>
      <!-- <svgicon icon="design-element-three" class="sidebar__design"></svgicon> -->
    </div>

    <div class="sidebar__blank" @click="toggleSidebar"></div>
  </div>
</template>

<script>
export default {
  name: "sidebar",
  props: {
    mobile: Boolean,
    toggleSidebar: Function
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/sidebar.vue